export const sxStyles = {
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    padding: '0.75rem 0.5rem',
  },
  flexWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  uploadButton: {
    display: 'flex',
    gap: '0.5rem',
    maxWidth: '92px',
  },
  checkbox: {
    display: 'flex',
    alignItems: 'start',

    '& > span:first-of-type': {
      paddingTop: 0,
    },
  },
};
